<template>
    <div>
        <div id="aiEditor" ref="editorEl" style="height: 550px;"></div>
    </div>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, onBeforeUnmount } from "vue";
import { AiEditor } from "aieditor";
import "aieditor/dist/style.css"

const props = defineProps({
    modelValue: {
        type: String,
        default: ''
    }
})
const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>()

const editorEl = ref<HTMLElement | null>(null)
let editor: AiEditor | null = null

onMounted(() => {
    editor = new AiEditor({
        element: editorEl.value as Element,
        placeholder: "点击输入内容...",
        content: props.modelValue,
        toolbarKeys: ["undo", "redo", "brush", "eraser",
            "|", "heading", "font-family", "font-size",
            "|", "bold", "italic", "underline", "strike", "link", "code", "subscript", "superscript", "hr", "todo", "emoji",
            "|", "highlight", "font-color",
            "|", "align", "line-height",
            "|", "bullet-list", "ordered-list", "indent-decrease", "indent-increase",
        ],
        onChange: (ed: AiEditor) => {
            emit('update:modelValue', ed.getHtml())
        }
    })
})

watch(() => props.modelValue, (val) => {
    if (!editor) return
    const current = editor.getHtml()
    if (val !== current) {
        editor.setContent(val || '')
    }
})

onBeforeUnmount(() => {
    if (editor) {
        editor.destroy()
        editor = null
    }
})
</script>
